import genericAvatar from "assets/images/generic_avatar.jpg";
import { ErrorModal, PageContainer } from "components";
import { MayTermSecondaryInfo } from "components/reusables";
import { AddEditMayTermModal } from "components/reusables/AddEditModals/AddEditMayTermModal";
import React, { useCallback, useState } from "react";
import { useAsync } from "react-async";
import { Button, Card, Col, Row } from "react-bootstrap";
import Img from "react-cool-img";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { getMayTermStory } from "services";
import { URLPaths } from "utilities";
import "./StoryDetails.scss";

export function AdminMayTermStoryDetails(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [isShowingEditMayTermModal, setIsShowingEditMayTermModal] = useState(false);
  const promiseFn = useCallback(() => getMayTermStory(id), [id]);
  const { data, error, isPending } = useAsync({ promiseFn });
  const mayTerm = data;
  const history = useHistory();

  const handleClick = () => {
    history.push("/map-view-admin");
  };

  if (!mayTerm && !isPending) return <Redirect to={URLPaths.mapViewAdmin} />;

  return (
    <>
      <PageContainer>
        <div>
          {mayTerm && (
            <Row>
              <Col xs={3}>
                <Img
                  src={mayTerm.photoUrl || ""}
                  placeholder={genericAvatar}
                  alt={`${mayTerm.organization}`}
                  width="100%"
                  loading="lazy"
                  className="img-circle"
                />
                <hr />
                <MayTermSecondaryInfo mayTerm={mayTerm} direction="column" />
                <hr />
                {/* <MayTermContactInfo mayTerm={mayTerm} /> */}
              </Col>
              <Col>
                <Row>
                  <Col>
                    <h1>Travel Opportunity in {mayTerm.location}</h1>
                  </Col>
                  <Col xs="auto">
                    <Button onClick={handleClick} variant="outline-danger">
                      Go Back
                    </Button>
                  </Col>
                  <Col xs="auto">
                    <Button
                      variant="outline-secondary"
                      onClick={() => setIsShowingEditMayTermModal(true)}
                    >
                      Edit
                    </Button>
                  </Col>
                </Row>

                {/* Sue was not a fan of the catchphrase.
                <Row>
                  <h3 className="catchphrase">
                    {mayTerm.catchphrase}
                    <br></br>
                  </h3>
                </Row> */}
                <hr />
                <Row>
                  <Col xs={8}>
                    <h4>About</h4>
                    <p className="p-breaks">{mayTerm.description}</p>
                  </Col>
                  <Col xs={4}>
                    {(mayTerm.quotes || []).length > 0 && (
                      <>
                        <h4>What Students Are Saying</h4>
                        <Card className="quotes">
                          <Card.Body>
                            {mayTerm.quotes?.map(quote => (
                              <MayTermQuote key={quote} quote={quote} />
                            ))}
                          </Card.Body>
                        </Card>
                      </>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          <ErrorModal error={error} />
        </div>
      </PageContainer>
      {!!mayTerm && (
        <AddEditMayTermModal
          show={isShowingEditMayTermModal}
          setShow={setIsShowingEditMayTermModal}
          // onCancel={() => setIsShowingEditMayTermModal(false)}
          currentMayTerm={mayTerm}
        />
      )}
    </>
  );
}

interface MayTermQuoteProps {
  quote: string;
}

function MayTermQuote({ quote }: MayTermQuoteProps): JSX.Element {
  return (
    <div className="quote d-flex flex-row">
      <span>&quot;{quote}&quot;</span>
    </div>
  );
}
